import React from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import AlertList from './AlertList';

const IN_PROGRESS_STATUSES = 'waiting_mandatory_reimbursement_file,waiting_sending,waiting_invoice';
const CUSTOMER_ALERT_STATUS = 'customer_alert';

const buildTpListUrl = (statusParam, scopedIds) => {
    const params = new URLSearchParams();
    params.set('status', statusParam);
    if (scopedIds && scopedIds.length > 0) {
        params.set('customerId', scopedIds.join(','));
    }
    return `/tiers-payant?${params.toString()}`;
};

const AlertCenter = ({stats}) => {
    const navigate = useNavigate();
    const alertCenter = stats?.alertCenter;
    if (!alertCenter) return null;

    const scopedIds = stats.scopedCustomerIds;

    return (
        <Card className="mt-4">
            <Card.Header as="h4">Centre d&apos;alerte</Card.Header>
            <Card.Body>
                <Row>
                    <Col md={6} className="mb-3 mb-md-0">
                        <AlertList
                            title="Réponses clients à traiter"
                            data={alertCenter.customerAlert}
                            onViewAll={() => navigate(buildTpListUrl(CUSTOMER_ALERT_STATUS, scopedIds))}
                        />
                    </Col>
                    <Col md={6}>
                        <AlertList
                            title="Dossiers en attente depuis +7 jours"
                            data={alertCenter.overdue}
                            onViewAll={() => navigate(buildTpListUrl(IN_PROGRESS_STATUSES, scopedIds))}
                            showDaysOverdue
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default AlertCenter;
